var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 28.6885C12.4942 28.6885 10.6092 28.3274 8.845 27.6053C7.08083 26.8599 5.54625 25.8583 4.24125 24.6005C2.93625 23.3426 1.89708 21.8635 1.12375 20.1631C0.374583 18.4627 0 16.6458 0 14.7124C0 12.779 0.374583 10.9622 1.12375 9.26173C1.89708 7.56131 2.93625 6.08218 4.24125 4.82433C5.54625 3.56648 7.08083 2.57651 8.845 1.85441C10.6092 1.10902 12.4942 0.736328 14.5 0.736328C16.5058 0.736328 18.3908 1.10902 20.155 1.85441C21.9192 2.57651 23.4538 3.56648 24.7588 4.82433C26.0638 6.08218 27.0908 7.56131 27.84 9.26173C28.6133 10.9622 29 12.779 29 14.7124C29 16.6458 28.6133 18.4627 27.84 20.1631C27.0908 21.8635 26.0638 23.3426 24.7588 24.6005C23.4538 25.8583 21.9192 26.8599 20.155 27.6053C18.3908 28.3274 16.5058 28.6885 14.5 28.6885ZM14.5 25.8933C17.7383 25.8933 20.4813 24.8101 22.7288 22.6438C24.9763 20.4775 26.1 17.8337 26.1 14.7124C26.1 11.5911 24.9763 8.94727 22.7288 6.78098C20.4813 4.61469 17.7383 3.53154 14.5 3.53154C11.2617 3.53154 8.51875 4.61469 6.27125 6.78098C4.02375 8.94727 2.9 11.5911 2.9 14.7124C2.9 17.8337 4.02375 20.4775 6.27125 22.6438C8.51875 24.8101 11.2617 25.8933 14.5 25.8933Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.44727L17 21.9414L9 15.1943L17 8.44727Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/BackIcon.a98e630d7e635d7fe7da380207bb9f35.svg";
export { ForwardRef as ReactComponent };